/*
 * subtitle-censor.js — чистка субтитров: лейн /profanity-remover-video.
 *
 * ЗАЧЕМ. Ролик уходит на площадку с двумя дорожками смысла: звуком и текстом.
 * Запикать звук и оставить слово напечатанным в субтитрах — это ролик, который
 * пройдёт по слуху и не пройдёт по тексту: площадки читают загруженный файл
 * субтитров, а зритель просто видит слово на экране.
 *
 * Здесь субтитры чистятся ТЕМ ЖЕ детектором и по тем же правилам, что и звук,
 * и таймкоды не сдвигаются ни на кадр — файл остаётся тем же файлом, меняются
 * только слова.
 *
 * ⚠️ Лейн ДОПОЛНИТЕЛЬНЫЙ: экспорт видео рядом не тронут, любой сбой разбора
 * возвращает сообщение, а не тупик.
 *
 * ⚠️ Кодировка. Русские .srt в дикой природе сплошь windows-1251, и
 * FileReader.readAsText() превращает их в кракозябры. Поэтому чтение идёт
 * через общий примитив SubtitleParser.decodeBytes — он же используется всеми
 * субтитровыми тулами проекта.
 */
(function (w) {
    'use strict';

    var d = document;
    var $ = function (id) { return d.getElementById(id); };

    function state() {
        try { return w.__pcTool && w.__pcTool._state ? w.__pcTool._state() : null; } catch (e) { return null; }
    }

    function attr(key, fallback) {
        var el = $('pc-subs-lane');
        var v = el && el.getAttribute('data-' + key);
        return v || fallback;
    }

    function say(msg) {
        var el = $('pc-subs-state');
        if (el) el.textContent = msg || '';
    }

    function report(action, extra) {
        try {
            var p = { tool: 'profanity-remover-video', feature: 'subtitle_censor', action: action };
            for (var k in (extra || {})) p[k] = extra[k];
            if (w.__ae) w.__ae('feature_use', p);
        } catch (e) {}
    }

    function refresh() {
        var lane = $('pc-subs-lane');
        if (!lane) return;
        var st = state();
        // Лейн имеет смысл, когда движок уже знает, ЧТО закрывать: список слов
        // берётся из того же разбора, что и звук.
        var show = !!(st && st.regions && st.regions.length);
        if (lane.hidden === !show) return;
        lane.hidden = !show;
        if (show) report('shown', { regions: st.regions.length });
    }

    /* Маска слова. Длину сохраняем: «б***» читается как цензура, а не как
       пропущенное слово, и строка не меняет ширину на экране. */
    function mask(word) {
        var chars = Array.from(word);
        if (chars.length <= 1) return '*';
        return chars[0] + new Array(chars.length).join('*');
    }

    /* Одна реплика субтитров → та же реплика с закрытыми словами. Разбор идёт
       по СЛОВАМ, а не по подстроке: подстрочный поиск закрывает половину
       безобидного слова, если мат в него случайно вложен. */
    function censorLine(text, detector, extraWords) {
        var changed = 0;
        var out = text.replace(/[\p{L}\p{N}'’-]+/gu, function (word) {
            var hit = null;
            try { hit = detector ? detector.scanToken(word, 1) : null; } catch (e) { hit = null; }
            if (!hit && extraWords && extraWords.indexOf(word.toLowerCase()) !== -1) hit = { manual: true };
            if (!hit) return word;
            changed++;
            return mask(word);
        });
        return { text: out, changed: changed };
    }

    async function handle(file) {
        var st = state();
        if (!file || !st) return;
        say(attr('msg-reading', 'Читаю субтитры…'));
        report('start', { ext: (file.name || '').split('.').pop() });

        try {
            if (!w.SubtitleParser) throw new Error('PARSER_MISSING');
            var text = w.SubtitleParser.readFile
                ? await w.SubtitleParser.readFile(file)
                : (w.SubtitleParser.decodeBytes(await file.arrayBuffer()) || {}).text;
            if (typeof text !== 'string' || !text.trim()) throw new Error('EMPTY');

            var cues = w.SubtitleParser.parse(text, { preserveMarkup: true }) || [];
            if (!cues.length) throw new Error('NO_CUES');

            var detector = null;
            try {
                if (w.ProfanityDetector && w.ProfanityDetector.create) {
                    detector = w.ProfanityDetector.create(st.activeLang || 'ru', st.settings || {});
                }
            } catch (e) { detector = null; }

            // Слова, которые человек отметил руками на дорожке, детектор не
            // знает — но в тексте они обязаны закрыться тоже, иначе субтитры
            // расходятся со звуком ровно там, где человек вмешался.
            var extra = [];
            (st.hits || []).forEach(function (h) { if (h && h.text) extra.push(String(h.text).toLowerCase()); });

            var total = 0;
            cues.forEach(function (c) {
                var r = censorLine(c.text || '', detector, extra);
                c.text = r.text;
                if (c.html) c.html = censorLine(c.html, detector, extra).text;
                total += r.changed;
            });

            if (!w.SubtitleSerializer) throw new Error('SERIALIZER_MISSING');
            var ext = (file.name || '').toLowerCase().endsWith('.vtt') ? 'vtt' : 'srt';
            var body = ext === 'vtt' ? w.SubtitleSerializer.toVtt(cues) : w.SubtitleSerializer.toSrt(cues);
            var base = (file.name || 'subtitles').replace(/\.[^.]+$/, '');
            var blob = new Blob([body], { type: 'text/plain;charset=utf-8' });
            if (w.__downloadFile) w.__downloadFile(blob, base + '_clean.' + ext);

            say((attr('msg-done', 'Закрыто слов:') + ' ' + total));
            report('done', { cues: cues.length, changed: total, ext: ext });
        } catch (e) {
            say('');
            report('failed', { error: ((e && e.message) || '').slice(0, 60) });
            if (w.__toast) w.__toast(attr('msg-failed', 'Не удалось разобрать файл субтитров. Поддерживаются SRT, VTT и ASS.'), 'warning');
        }
    }

    function boot() {
        var btn = $('pc-subs-pick'), input = $('pc-subs-input');
        if (!btn || !input) return;
        btn.addEventListener('click', function () { input.click(); });
        input.addEventListener('change', function () {
            var f = input.files && input.files[0];
            // Значение чистим, чтобы повторный выбор ТОГО ЖЕ файла снова дал
            // событие — правило общего аплоадера, и здесь оно тоже верно.
            input.value = '';
            if (f) handle(f);
        });
        refresh();
        setInterval(refresh, 1200);
    }

    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
    else boot();
})(window);
